import React from 'react';
import {CSSTransition} from "react-transition-group";
import classes from "../friends/referrals/referrals.module.css";

const Info = ({isOpen, setIsOpen}) => {
    return (
        <>
            <CSSTransition in={isOpen}
                           timeout={300}
                           classNames="openBlock"
                           unmountOnExit>
                <div className={classes.fon} onClick={()=>setIsOpen(false)}></div>
            </CSSTransition>
            <CSSTransition in={isOpen}
                           timeout={300}
                           classNames="openBonusMenu"
                           unmountOnExit>
                <div className={classes.block2}>
                    <div className={classes.close} onClick={()=>setIsOpen(false)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M11.9997 10.5865L16.2424 6.34382C16.6329 5.9533 17.2661 5.9533 17.6566 6.34382C18.0471 6.73435 18.0471 7.36751 17.6566 7.75803L13.4139 12.0007L17.6566 16.2433C18.0471 16.6338 18.0471 17.267 17.6566 17.6575C17.2661 18.048 16.6329 18.048 16.2424 17.6575L11.9997 13.4149L7.75706 17.6575C7.36654 18.048 6.73338 18.048 6.34286 17.6575C5.95233 17.267 5.95233 16.6338 6.34286 16.2433L10.5855 12.0007L6.34285 7.75804C5.95232 7.36751 5.95233 6.73435 6.34285 6.34382C6.73338 5.9533 7.36654 5.9533 7.75707 6.34383L11.9997 10.5865Z" fill="white"/>
                        </svg>
                    </div>
                    <div className={classes.text1}>Условия конкурса</div>
                    <div className={classes.text2}>
                        1. ОБЩИЕ ПОЛОЖЕНИЯ
                        <br/>1.1. Настоящие условия регулируют проведение конкурса.
                        <br/>1.2. Организатором Конкурса является Администрация VPN-сервиса EasyFastVPN.
                        <br/>1.3. Конкурс не является лотереей или азартной игрой и проводится в соответствии с законодательством РФ.
                        <br/>1.4. Участие в Конкурсе означает полное и безоговорочное согласие Участника с настоящими условиями.
                        <br/>
                        <br/>2. СРОКИ ПРОВЕДЕНИЯ КОНКУРСА
                        <br/>Начало: «1» сентября 2024 года в 00:00 по московскому времени.
                        <br/>Окончание: «30» сентября 2024 года в 23:59 по московскому времени.
                        <br/>
                        <br/>3. УСЛОВИЯ УЧАСТИЯ И МЕХАНИЗМ ПРОВЕДЕНИЯ
                        <br/>3.1. Участником Конкурса может стать любой пользователь VPN-сервиса, имеющий уникальную реферальную ссылку/код.
                        <br/>3.2. Для участия необходимо:
                        <br/>* Приглашать новых пользователей, используя свою реферальную ссылку из раздела «Друзья» в боте.
                        <br/>* Приглашенный пользователь должен начать пользоваться VPN.
                        <br/>3.3. ВАЖНО: Не учитываются:
                        <br/>* Повторные регистрации уже существующих пользователей.
                        <br/>* Пользователи, приглашенные до начала или после окончания текущего этапа Конкурса.
                        <br/>* Пользователи, привлеченные с использованием запрещенных методов (см. п. 4.3).
                        <br/>3.4. Количество приглашенных пользователей отображается в таблице лидеров.
                        <br/>
                        <br/> 4. ПОДСЧЕТ РЕЗУЛЬТАТОВ И ОПРЕДЕЛЕНИЕ ПОБЕДИТЕЛЕЙ
                        <br/> 4.1. Победителями признаются десять Участников, пригласившие наибольшее количество новых пользователей за период Конкурса.
                        <br/> * 🥇 1 место: 10 000 (Десять тысяч) рублей + безлимитная подписка.
                        <br/> * 🥈 2 место: 5 000 (Пять тысяч) рублей + безлимитная подписка.
                        <br/> * 🥉 3 место: 3 000 (Три тысячи) рублей + безлимитная подписка.
                        <br/> * 4 место: безлимитная подписка.
                        <br/> * 5 место: безлимитная подписка.
                        <br/> * 6 место: подписка на год.
                        <br/> * 7 место: подписка на год.
                        <br/> * 8 место: подписка на год.
                        <br/> * 9 место: подписка на год.
                        <br/> * 10 место: подписка на год.
                        <br/> 4.2. В случае равенства количества приглашенных у двух и более Участников, победитель определяется по дате и времени приглашенных. Выше место занимает тот, чье приглашение было совершено раньше.
                        <br/> 4.3. Запрещенные методы: Использование ботов, создание фейковых аккаунтов, мошеннические схемы, спам-рассылки в чужих чатах без согласия администрации. Участники, уличенные в нечестной игре, немедленно дисквалифицируются без объяснения причин.
                        <br/>
                        <br/> 5. ВЫПЛАТА ПРИЗОВ
                        <br/>5.1. Итоги Конкурса подводятся в течение 3 (трех) рабочих дней с даты его окончания.
                        <br/>5.2. Список победителей публикуется в приложении сервиса и дублируется в виде рассылки через бота.
                        <br/>5.3. Для получения приза Победитель обязан в течение 5 (пяти) рабочих дней после объявления результатов:
                        <br/>* а) Написать в техническую поддержку бота: <a style={{color:"white"}} href={'https://t.me/easyfastvpn'}>@easyfastvpn</a>.
                        <br/>* б) Предоставить реквизиты для перевода (номер банковской карты, счет или номер телефона для СБП).
                        <br/>5.4. Выплата денежного приза осуществляется безналичным переводом на указанные реквизиты в течение 7 (семи) рабочих дней.
                        <br/>
                        <br/>6. ПРОЧИЕ УСЛОВИЯ
                        <br/>6.1. Организатор оставляет за собой право вносить изменения в условия Конкурса с обязательным уведомлением всех Участников через рассылку в боте.
                        <br/>6.2. Все спорные ситуации решаются путем переговоров. В случае невозможности достижения согласия спор подлежит разрешению в соответствии с законодательством Российской Федерации.
                        <br/>6.3. Вопросы, не урегулированные настоящими условиями, разрешаются Организатором по его собственному усмотрению.
                        <br/><br/>
                        УДАЧИ В КОНКУРСЕ! ВАША АКТИВНОСТЬ — НАШ ОБЩИЙ УСПЕХ! 🚀
                    </div>
                </div>
            </CSSTransition>
        </>
    );
};

export default Info;